import OrganizationSelect from './container';

export default OrganizationSelect;
